/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Pricing Data is a collection of Price Datum by region
 */

import { Bizo, autoclass } from '../../shared/bizos/base'
import { decode } from '../../shared/utils/columnar'

const SPEC = {
  0: [{ created_on: 'delta | rle', median_price: 'delta', uncertain: 'true' }],
  1: [{ created_on: 'delta | rle', median_price: 'delta', uncertain: 'true' }],
  2: [{ created_on: 'delta | rle', median_price: 'delta', uncertain: 'true' }],
  3: [{ created_on: 'delta | rle', median_price: 'delta', uncertain: 'true' }],
  4: [{ created_on: 'delta | rle', median_price: 'delta', uncertain: 'true' }],
}

/**
 *
 * @type {{
  new (
    d?: object
  ): Readonly<import('@zcode/state-type').NewPriceData> & Bizo<import('@zcode/state-type').NewPriceData, import('@zcode/state-type').unknown>
  static fromJS: (
      (
        data: object
      ) => Readonly<import('@zcode/state-type').NewPriceData> & Bizo<import('@zcode/state-type').NewPriceData, object>
    ) &
    ((data?: undefined) => undefined) &
    (<T extends 0 | 0n | false | '' | null>(data?: T) => T)
}}
 */
export const NewPriceData = autoclass(
  'PriceData',
  class PriceData extends Bizo {},
  {
    data: (t) => {
      const decoded = decode(t._data, SPEC)
      const bedrooms = new Array(5)
      for (const br in decoded) {
        const prices = decoded[br]
        bedrooms[Number.parseInt(br)] = {
          labels: prices.map((p) => p.created_on),
          series: prices.map((p) => ({
            x: p.created_on,
            y: p.median_price,
          })),
          uncertain: prices.map((p) => p.uncertain),
        }
      }

      return bedrooms
    },
  },
  null
)

export default {
  fromJS: (data) => data ?? [],
}
